import { useSelector } from 'react-redux';

import {
  selectIsDockVisible,
  selectPinnedDocs,
} from '@/services/slices/pinnedDocsSlice';

import { DockTabBar } from './DockTabBar';
import { FullscreenModal } from './FullscreenModal';
import { MiniPreviewPanel } from './MiniPreviewPanel';

/**
 * PinnedDocsDock - Gmail-style pinned documents dock
 *
 * Features:
 * - Tab bar at bottom of screen showing pinned documents
 * - Mini preview panel (600x700) for quick viewing
 * - Fullscreen modal for detailed viewing
 * - Cross-matter document pinning with navigation
 *
 * Add this component to MainLayout to enable the dock globally.
 */
export const PinnedDocsDock = () => {
  const pinnedDocs = useSelector(selectPinnedDocs);
  const isDockVisible = useSelector(selectIsDockVisible);

  // Don't render anything if dock is hidden or no pinned docs
  if (!isDockVisible || pinnedDocs.length === 0) {
    return null;
  }

  return (
    <>
      {/* Tab bar at bottom */}
      <DockTabBar />

      {/* Mini preview panel (when expanded) */}
      <MiniPreviewPanel />

      {/* Fullscreen modal (when maximized) */}
      <FullscreenModal />
    </>
  );
};

export default PinnedDocsDock;
